<template>
  <div class="comp-news">
    <ul v-if="data && data.length">
      <li class="pic" v-for="item in headData" :key="item.Id">
        <div class="left">
          <router-link :to="item.link" :target="target">
            <img @error="imgError" :src="item.Illustration" alt="item.text" />
          </router-link>
        </div>
        <div class="right">
          <h3>
            <router-link :to="item.link" :target="target">{{
              item.Headline
            }}</router-link>
          </h3>
          <p>{{ item.Summary }}</p>
        </div>
      </li>
      <li class="text" v-for="item in tailData" :key="item.id">
        <router-link :to="item.link" :target="target">
          <span>{{ item.Headline }}</span>
          <span class="date">{{ item.IssueTime }}</span>
        </router-link>
      </li>
    </ul>
    <div v-else class="g-nodata"></div>
  </div>
</template>

<script>
export default {
  name: "ic-mix-news",
  props: {
    data: {
      type: Array
    },
    target: {
      type: String,
      default: "_self"
    },
    top: {
      type: Number,
      default: 1
    }
  },
  computed: {
    headData() {
      return this.data.slice(0, this.top);
    },
    tailData() {
      return this.data.slice(this.top, this.data.length);
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-news {
  display: flex;
  justify-content: space-between;
  ul {
    width: 100%;
  }
  li {
    position: relative;
    h3 {
      color: rgba(51, 51, 51, 1);
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
    }
    p {
      font-size: 12px;
      color: #999;
      line-height: 20px;
      @include ellipsisc(4);
    }
    &.text {
      padding: 10px 0 10px 10px;
      border-bottom: 1px solid #eeeeee;
      a {
        &::before {
          background-color: #999;
          width: 4px;
          height: 4px;
          display: inline-block;
          content: ' ';
          position: absolute;
          left: 0;
          top: 21px;
        }
        &:hover {
          &::before {
            background-color: $primary-color;
          }
        }
        .date {
          float: right;
          color: #999;
        }
      }
    }
    &.pic {
      display: flex;
      .left {
        width: 156px;
        height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 24px;
      }
      .right {
        width: calc(100% - 180px);
        display: flex;
        overflow: hidden;
        flex-direction: column;
      }
    }
  }
}
</style>
